<template>
  <div id="hemoglobina-glicada" class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="true"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
        <b-tab title="Lista" active @click="buscarDadosDaLista()">
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setRed="setRed"
                      @resetarNome="setRed = false"
                    ></Subtitle>
                  </div>
                  <div class="select-situacao info-table-item">
                    <vue-select
                      :options="situacao_opcoes"
                      label="situacao"
                      placeholder="Último Atendimento"
                      v-model="situacao"
                      @input="
                        situacao !== null
                          ? filtros(
                              exibirCadastrosVermelhos,
                              exibirCadastrosVerdes,
                              $event
                            )
                          : filtros(
                              exibirCadastrosVermelhos,
                              exibirCadastrosVerdes,
                              { situacao: 'Todos' }
                            )
                      "
                      :clearable="true"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.situacao }}
                      </template>
                      <div slot="no-options">Não há opções correspondentes</div>
                    </vue-select>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="hemoglobina-glicada"
                    >
                    </download-files>
                  </div>
                </div>

                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loadingLista"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Resultado" @click="buscarDadosDoResultado()">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-lg-12">
              <div class="resultado-hemoglobina-glicada">
                <b-tabs
                  id="tabs-2"
                  key="tabs-2"
                  fill
                  class="esus-feedback-tabs"
                  v-model="tabsActive2"
                >
                  <b-tab title="resultado" active>
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Tabela"
                        class="icon-tooltip icofont-table"
                      ></i>
                    </template>
                  </b-tab>
                  <b-tab title="grafico">
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Gráfico"
                        class="icon-tooltip icofont-chart-bar-graph"
                      ></i>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
              <tabela-secretaria
                v-if="tabsActive2 === 0"
                :no_municipio_estimadas="parseInt(no_municipio_estimadas)"
                :no_municipio_informadas="parseInt(no_municipio_informadas)"
                :no_municipio_numerador="parseInt(no_municipio_numerador)"
                :no_municipio_resultado="parseInt(no_municipio_resultado)"
                :no_municipio_percent_cad_sisab="
                  parseInt(no_municipio_percent_cad_sisab)
                "
                :no_municipio_cad_sisab="parseInt(no_municipio_cad_sisab)"
                :na_equipe_estimadas="parseInt(na_equipe_estimadas)"
                :na_equipe_informadas="parseInt(na_equipe_informadas)"
                :na_equipe_numerador="parseInt(na_equipe_numerador)"
                :na_equipe_resultado="parseInt(na_equipe_resultado)"
                :no_acs_informadas="parseInt(no_acs_informadas)"
                :no_acs_numerador="parseInt(no_acs_numerador)"
                :no_acs_resultado="parseInt(no_acs_resultado)"
                :no_municipio_meta="no_municipio_meta"
                :na_equipe_meta="na_equipe_meta"
                :no_acs_meta="no_acs_meta"
                :loading="loadingResultado"
                :cod_ibge="cod_ibge"
              >
              </tabela-secretaria>
              <div v-if="tabsActive2 === 1">
                <secretaria-grafico
                  :no_municipio_cad_sisab="parseInt(no_municipio_cad_sisab)"
                  :no_municipio_percent_cad_sisab="
                    parseInt(no_municipio_percent_cad_sisab)
                  "
                  :arrayChartMunicipio="arrayChartMunicipio"
                  :arrayChartEquipe="arrayChartEquipe"
                  :arrayChartAcs="arrayChartAcs"
                  :temEquipe="temEquipe"
                  :temAcs="temAcs"
                  :no_municipio_estimadas="parseInt(no_municipio_estimadas)"
                  :no_municipio_informadas="parseInt(no_municipio_informadas)"
                  :no_municipio_numerador="parseInt(no_municipio_numerador)"
                  :no_municipio_resultado="parseInt(no_municipio_resultado)"
                  :na_equipe_estimadas="parseInt(na_equipe_estimadas)"
                  :na_equipe_informadas="parseInt(na_equipe_informadas)"
                  :na_equipe_numerador="parseInt(na_equipe_numerador)"
                  :na_equipe_resultado="parseInt(na_equipe_resultado)"
                  :no_acs_informadas="parseInt(no_acs_informadas)"
                  :no_acs_numerador="parseInt(no_acs_numerador)"
                  :no_acs_resultado="parseInt(no_acs_resultado)"
                >
                </secretaria-grafico>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Gráfico" @click="buscarDadosDoGrafico()">
          <pulse-loader
            :loading="loadingGrafico"
            :color="color"
            :size="size"
            class="vue-loader"
          ></pulse-loader>
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> Gráfico
          </template>
          <div class="row">
            <div class="col-lg-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-chart-bar-graph"></i> Série Histórica
                  </h4>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <apexchart
                        type="line"
                        height="350"
                        :options="chartOptions"
                        :series="chartData"
                        ref="chartData"
                      ></apexchart>
                      <tabela-serie-historica
                        :xaxis="xaxis"
                        :chartOptions="chartOptions"
                        :arrayChartMunicipio="arrayChartMunicipio"
                        :arrayChartEquipe="arrayChartEquipe"
                        :arrayChartAcs="arrayChartAcs"
                        :equipe="equipe"
                        :profissional="profissional"
                      />
                      <p class="fonte">
                        <b>Fonte:</b> e-SUS PEC, {{ data_dados_chart }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Subtitle from './Subtitle'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions'
import TabelaSecretaria from './TabelaSecretaria.vue'
import SecretariaGrafico from './SecretariaGrafico.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import { chartOptions, dataFields, infoHtml } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import tabelaSerieHistorica from '@/components/tabelaSerieHistorica'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'HemoglobinaGlicadaPorEquipeAcs',
  components: {
    PulseLoader,
    Subtitle,
    Loader,
    apexchart: VueApexCharts,
    'tabela-secretaria': TabelaSecretaria,
    'secretaria-grafico': SecretariaGrafico,
    DownloadFiles,
    tabelaSerieHistorica,
    TabelaCadastros,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      tabsActive: 0,
      tabsActive2: 0,
      temEquipe: false,
      temAcs: false,
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      loadingResultado: false,
      loadingLista: false,
      loadingGrafico: false,
      size: '40px',
      color: '#0D98BB',
      no_municipio_estimadas: 0,
      no_municipio_numerador: 0,
      no_municipio_informadas: 0,
      no_municipio_resultado: 0,
      no_municipio_percent_cad_sisab: 0,
      no_municipio_cad_sisab: 0,
      na_equipe_estimadas: 0,
      na_equipe_numerador: 0,
      na_equipe_informadas: 0,
      na_equipe_resultado: 0,
      no_acs_numerador: 0,
      no_acs_informadas: 0,
      no_acs_resultado: 0,
      no_municipio_meta: 0,
      na_equipe_meta: 0,
      no_acs_meta: 0,
      nomeEquipe: '',
      nomeProfissional: '',
      arrayChartMunicipio: [],
      arrayChartEquipe: null,
      arrayChartAcs: null,
      data_dados_chart: '',
      xaxis: [],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      micro_areas: [],
      micro_area: '',
      dadosDoResultado: [],
      dataFields: {
        ...dataFields,
      },
      situacao_opcoes: [
        {
          situacao: 'Todos',
        },
        {
          situacao: 'Auto referido',
        },
        {
          situacao: 'Últimos 30 dias',
        },
        {
          situacao: 'Últimos 2 meses',
        },
        {
          situacao: 'Últimos 3 meses',
        },
        {
          situacao: 'Últimos 4 meses',
        },
        {
          situacao: 'Entre 4 - 6 meses',
        },
        {
          situacao: 'Entre 6 - 12 meses',
        },
        {
          situacao: '12 ou + meses',
        },
        {
          situacao: 'No numerador? Sim.',
        },
        {
          situacao: 'No numerador? Não.',
        },
      ],
      situacao: '',
      cadastrosOriginais: [],
      setRed: false,
      text: infoHtml,
      equipeEvent: '',
      filterSearchTable: false,
    }
  },
  watch: {},
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde, situacao) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      // Se null setar como vazio
      if (situacao === null) {
        this.situacao = ''
        situacao = ''
      }
      if (situacao !== '') {
        data = Functions.handleSituacao(data, situacao.situacao)
      }
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false, this.situacao)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true, this.situacao)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.equipeEvent = event
        this.situacao = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.profissionais = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = event.nu_ine
        this.nomeEquipe = event.no_equipe
        if (event.nu_ine != 'sem-equipe') {
          this.buscarCadastrosIndividuaisTodosPorEquipe()
        } else {
          this.profissionais = []
          this.buscarCadastrosIndividuaisSemEquipe()
        }
      } else {
        this.equipeEvent = ''
        this.temEquipe = false
        this.temAcs = false
        this.profissionais = []
        this.profissional = ''
        this.situacao = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.micro_area = ''
        this.micro_areas = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''
        this.nomeEquipe = ''
        return
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.profissional = event?.nu_cpf
        this.nomeProfissional = event?.no_profissional
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.buscarDadosDaLista()
      } else {
        this.situacao = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.temAcs = false
        this.profissional = ''
        this.nomeProfissional = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.onChangeEquipe(this.equipeEvent)
        return
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.loadingLista = true
        this.nomeProfissional = ''
        this.profissional = null
        this.micro_area = event?.micro_area
        this.tabsActive = 0
        this.tabsActive2 = 0
        if (this.micro_area == undefined) {
          this.tabsActive = 0
          this.tabsActive2 = 0
        }
        if (this.micro_area !== undefined) {
          let response = await Functions.getCadastrosIndividuaisPorMicroArea(
            this.$store.state.cod_ibge,
            this.equipe,
            this.micro_area
          )
          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.tabsActive = 0
            this.filtros(true, false, this.situacao)
            this.setRed = true
            this.loadingLista = false
          }
        }
      } else {
        this.cadastrosOriginais = []
        this.cadastros = []
        this.situacao = ''
        this.nomeProfissional = ''
        this.profissional = ''
        this.micro_area = ''
        this.tabsActive = 0
        this.tabsActive2 = 0
        this.onChangeEquipe(this.equipeEvent)
      }
    },

    async buscarDadosDoResultado() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.temEquipe = false
      this.temAcs = false
      this.tabsActive2 = 0
      this.na_equipe_estimadas = 0
      this.na_equipe_informadas = 0
      this.na_equipe_numerador = 0
      this.na_equipe_resultado = 0
      this.no_acs_numerador = 0
      this.no_acs_informadas = 0
      this.no_acs_resultado = 0
      this.no_acs_meta = 0
      this.loadingResultado = true
      try {
        if (this.dadosDoResultado.length === 0) {
          // busca os dados
          let response = await this.$api.get(
            '/app/indicadores-aps/resultado/' +
              this.$store.state.cod_ibge +
              '/7'
          )
          if (response) {
            this.dadosDoResultado = response.data
          }
        }

        // Pega série histórica do municipio
        if (this.arrayChartMunicipio.length === 0) {
          await this.carregarSerieHistorica()
        }

        // dados do município
        const dadosDoMunicipio = this.dadosDoResultado.find((item) => {
          return item.ibge_ine === 'MUN'
        })
        this.no_municipio_estimadas = dadosDoMunicipio.estimativa
        this.no_municipio_informadas = dadosDoMunicipio.denominador
        this.no_municipio_numerador = dadosDoMunicipio.numerador
        this.no_municipio_resultado = dadosDoMunicipio.resultado
        this.no_municipio_percent_cad_sisab = dadosDoMunicipio.percent_cad_sisab
        this.no_municipio_cad_sisab = dadosDoMunicipio.cad_sisab
        if (parseInt(this.no_municipio_resultado) > 100) {
          this.no_municipio_resultado = 100
        }

        // dados da equipe
        if (
          this.equipe !== '' &&
          this.equipe !== null &&
          this.equipe !== 'sem-equipe'
        ) {
          let equipe = await this.$api.get(
            '/app/equipe/' + this.$store.state.cod_ibge + '/' + this.equipe
          )
          if (equipe) {
            // Pega série histórica da equipe
            if (this.arrayChartEquipe === null) {
              await this.carregarSerieHistoricaPorEquipe(equipe.data.nu_ine)
            }

            const dadosDaEquipe = this.dadosDoResultado.find((item) => {
              return item.ibge_ine === equipe.data.nu_ine
            })

            this.temEquipe = true
            this.na_equipe_estimadas = dadosDaEquipe.estimativa
            this.na_equipe_informadas = dadosDaEquipe.denominador
            this.na_equipe_numerador = dadosDaEquipe.numerador
            this.na_equipe_resultado = dadosDaEquipe.resultado
          }
        } else {
          this.temEquipe = false
          this.temAcs = false
        }

        // dados do acs
        if (
          this.profissional !== '' &&
          this.profissional !== null &&
          this.profissional !== 'todos'
        ) {
          const profissional = await this.$api.get(
            '/app/profissional/' +
              this.profissional +
              '/' +
              this.$store.state.cod_ibge
          )
          if (profissional) {
            this.nomeProfissional = profissional.data.no_profissional
            const dadosDoAcs = this.dadosDoResultado.find((item) => {
              return item.ibge_ine === profissional.data.nu_cpf
            })

            if (dadosDoAcs !== undefined) {
              // Pega série histórica do profissional
              if (this.arrayChartAcs === null) {
                await this.carregarSerieHistoricaAcs()
              }

              this.temAcs = true
              this.no_acs_informadas = dadosDoAcs.denominador
              this.no_acs_numerador = dadosDoAcs.numerador
              this.no_acs_resultado = dadosDoAcs.resultado
              if (this.no_acs_resultado > 100) {
                this.no_acs_resultado = 100
              }
            }
          }
        } else {
          this.temAcs = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingResultado = false
      }
    },

    async buscarDadosDaLista() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (this.profissional !== '' && this.profissional !== null) {
        this.loadingLista = true
        try {
          if (
            this.profissional !== 'sem-acs' &&
            this.profissional !== 'todos'
          ) {
            const profissional = await this.$api.get(
              '/app/profissional/' +
                this.profissional +
                '/' +
                this.$store.state.cod_ibge
            )
            let response = await Functions.getCadastrosIndividuais(
              this.$store.state.cod_ibge,
              profissional.data.nu_cpf,
              this.situacao.situacao
            )
            if (response) {
              this.cadastros = response
              this.cadastrosOriginais = response
              this.filtros(true, false, this.situacao)
              this.setRed = true
            }
          }
          if (this.profissional === 'sem-acs') {
            this.buscarCadastrosIndividuaisSemAcs()
          }
          if (this.profissional === 'todos') {
            this.buscarCadastrosIndividuaisTodosPorEquipe()
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    async buscarCadastrosIndividuaisSemEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisSemEquipe(
        this.$store.state.cod_ibge
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(true, false, this.situacao)
        this.setRed = true
        this.loadingLista = false
      }
    },

    async buscarCadastrosIndividuaisTodosPorEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(true, false, this.situacao)
        this.setRed = true
        this.loadingLista = false
      }
    },

    async buscarDadosDoGrafico() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.loadingGrafico = true
      if (this.arrayChartMunicipio.length === 0) {
        await this.carregarSerieHistorica()
      }
      if (this.equipe !== '') {
        //pega a equipe do acs
        let equipe = await this.$api.get(
          '/app/equipe/' + this.$store.state.cod_ibge + '/' + this.equipe
        )
        if (equipe) {
          this.nomeEquipe = equipe.data.no_equipe
          await this.carregarSerieHistoricaPorEquipe(equipe.data.nu_ine)
          this.loadingGrafico = false
        }
        if (this.profissional !== '') {
          // Pega a série histórica do acs
          await this.carregarSerieHistoricaAcs()
        }
      }
      this.loadingGrafico = false
    },

    async carregarSerieHistorica() {
      this.$api
        .get(
          '/app/serie-historica/municipio/' + this.$store.state.cod_ibge + '/7'
        )
        .then((response) => {
          let array_chart_municipio = []
          let array_xaxis = []
          //carregar eixo x
          for (let i = 0; i < response.data.length; i++) {
            array_xaxis.push(response.data[i].mes_ano)
            this.xaxis.push(response.data[i].mes_ano)
          }
          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis,
            },
          })
          // carregar dados do município
          for (let i = 0; i < response.data.length; i++) {
            array_chart_municipio.push(response.data[i].resultado)
          }
          this.$refs.chartData.updateSeries([
            {
              name: 'Município',
              data: array_chart_municipio,
            },
          ])
          this.arrayChartMunicipio = array_chart_municipio
          this.data_dados_chart = this.formatDate(
            response.data[response.data.length - 1].data_dados
          )
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    async carregarSerieHistoricaPorEquipe(nu_ine) {
      let array_chart_equipe = await Functions.carregarSerieHistoricaPorEquipe(
        this.$store.state.cod_ibge,
        nu_ine,
        this.xaxis
      )
      this.arrayChartEquipe = array_chart_equipe
      this.$refs.chartData.updateSeries([
        {
          name: 'MUNICÍPIO',
          data: this.arrayChartMunicipio,
        },
        {
          name: this.nomeEquipe,
          data: array_chart_equipe,
        },
      ])
    },

    async carregarSerieHistoricaAcs() {
      let arrayChartAcs = await Functions.carregarSerieHistoricaPorAcs(
        this.$store.state.cod_ibge,
        this.profissional,
        this.xaxis
      )

      if (arrayChartAcs !== null) {
        this.arrayChartAcs = arrayChartAcs
        this.$refs.chartData.updateSeries([
          {
            name: 'MUNICÍPIO',
            data: this.arrayChartMunicipio,
          },
          {
            name: this.nomeEquipe,
            data: this.arrayChartEquipe,
          },
          {
            name: 'ACS',
            data: arrayChartAcs,
          },
        ])
      } else {
        this.arrayChartAcs = null
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipeEvent,
        this.profissional,
        this.nomeProfissional
      )
    },
  },
  created() {},
}
</script>

<style>
.info-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 15px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
</style>
<style scoped lang="scss">
.main {
  min-height: unset;
  margin-bottom: 0;
}
.select-situacao {
  margin: 10px;
  min-width: 210px;
}
@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
}
</style>
<style>
#hemoglobina-glicada .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#hemoglobina-glicada .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#hemoglobina-glicada .select-situacao .v-select {
  width: 296px;
}
#hemoglobina-glicada .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
<style>
.resultado-hemoglobina-glicada {
  cursor: pointer !important;
  display: flex !important;
  padding: 10px 1rem !important;
  gap: 15px !important;
  font-size: 20px !important;
  color: black !important;
  background: white !important;
  justify-content: flex-end !important;
  padding-bottom: 5px !important;
}
.resultado-hemoglobina-glicada .esus-feedback-tabs ul li .nav-link {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.resultado-hemoglobina-glicada .esus-feedback-tabs ul {
  background: #0fafd726 !important;
  border-radius: 5px !important;
  padding: 0px 1px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.resultado-hemoglobina-glicada .esus-feedback-tabs ul li .nav-link.active {
  transition: all ease 0.3s !important;
  border-color: unset !important;
  border-bottom: unset !important;
  border: unset !important;
}
.resultado-hemoglobina-glicada
  .esus-feedback-tabs
  ul
  li:first-child
  .nav-link.active {
  background-color: #0056b3 !important;
  color: white !important;
  border-radius: 5px 0px 0px 5px !important;
  animation: left 0.5s ease 0s 1 normal forwards !important;
}
.resultado-hemoglobina-glicada
  .esus-feedback-tabs
  ul
  li:last-child
  .nav-link.active {
  background-color: #0056b3 !important;
  color: white !important;
  border-radius: 0px 5px 5px 0px !important;
  animation: right 0.5s ease 0s 1 normal forwards !important;
}
.resultado-hemoglobina-glicada .nav-tabs {
  border-bottom: unset;
}
@keyframes right {
  0% {
    transform: translateX(-40px);
  }

  100% {
    transform: translateX(0px);
  }
}
@keyframes left {
  0% {
    transform: translateX(40px);
  }

  100% {
    transform: translateX(0px);
  }
}
</style>
